<template>
  <div class="animated fadeIn">
    <div v-show="hasProducts">
      <Tables
        ref="tableGrid"
        :columns="[
          $lang.Common.DataTable.ProductTable.Date,
          $lang.Common.DataTable.ProductTable.Product,
          $lang.Common.DataTable.ProductTable.Operation,
          $lang.Common.DataTable.ProductTable.DaysLate,
          $lang.Common.DataTable.ProductTable.Value,
          $lang.Common.DataTable.ProductTable.Risk,
          $lang.Common.DataTable.ProductTable.Observation,
          $lang.Common.DataTable.Actions
        ]"
        v-on:Load="onLoad"
        v-if="checkTypeBoard(card, 'COBRANCA')"
      >
        <tr v-for="obj in this.objList" v-bind:key="obj.id">
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="formatDate(obj.data, true)"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="obj.produtoDTO ? obj.produtoDTO.nome : ''"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="obj.operacao"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="obj.diasAtraso ? obj.diasAtraso.toString() : ''"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="formatValue(obj.valor)"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="obj.risco"
          />
          <TableColumn :IsCustom="true">
            <td
              class="text-center text-third"
              style="font-size: 16px;border:0px;padding: 0px 0px 0px  35px; "
              v-if="obj.observacao"
            >
              <span>
                <strong v-b-tooltip.hover :title="obj.observacao">
                  <i class="fas fa-comment"></i>
                </strong>
              </span>
            </td>
          </TableColumn>
          <TableColumn
            :IsActionsButtons="true"
            :HasChange="false"
            v-on:Delete="deleteProduct(obj)"
            :status="obj.status"
          />
        </tr>
        <template slot="table-footer">
          <tr>
            <td colspan="3" class="text-right text-third">
              <strong
                ><i class="fas fa-funnel-dollar text-third"></i>&nbsp;
                {{ formatValue(totalValue) }}</strong
              >
            </td>
            <td colspan="2">&nbsp;</td>
          </tr>
        </template>
      </Tables>

      <Tables
        ref="tableGrid"
        :columns="columnsVenda"
        v-on:Load="onLoad"
        v-else
      >
        <tr v-for="obj in this.objList" v-bind:key="obj.id">
          <TableColumn :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="formatDate(obj.data, true)"
          />
          <TableColumn :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="obj.produtoDTO ? obj.produtoDTO.nome : ''"
          />
          <TableColumn :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="formatValue(obj.valor)"
          />
          <TableColumn :IsCustom="true">
            <td
              :class="[textColorProduct(obj) !== '' ? textColorProduct(obj) : 'text-third']"
              style="font-size: 16px;border:0px;padding: 0px 0px 0px  35px; "
              v-if="obj.observacao"
            >
              <span
                ><strong v-b-tooltip.hover :title="obj.observacao"
                  ><i class="fas fa-comment"></i></strong
              ></span>
            </td>
          </TableColumn>
          <template v-if="checkTypeBoard(card, 'VENDA')">
            <td v-show="cardIsActive">
              <ActionButtonProduct
                :product="obj"
                @ActionProduct="actionProduct"
              />
            </td>
          </template>
          <template v-else>
            <TableColumn
              :IsActionsButtons="true"
              :HasChange="false"
              v-on:Delete="deleteProduct(obj)"
              :status="obj.status"
            />
          </template>
        </tr>
        <template slot="table-footer">
          <tr>
            <td colspan="3" class="text-right text-third">
              <strong
                ><i class="fas fa-funnel-dollar text-third"></i>&nbsp;
                {{ formatValue(totalValue) }}</strong
              >
            </td>
            <td colspan="2">&nbsp;</td>
          </tr>
        </template>
      </Tables>
    </div>
    <div v-show="!hasProducts">
      Nenhum produto cadastrado,
      <strong @click="onAddProduct" style="cursor: pointer"
        >clique para adicionar</strong
      >
    </div>
    <ModalAddProduct
      v-if="!boardArchived"
      ref="ModalAddProduct"
      :card="card"
      v-on:Reload="onReload"
    />
  </div>
</template>

<script>
import CrmDetailsProduct from './product.js'
export default CrmDetailsProduct
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/product/product.vue